// src/components/AddToCartButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'react-bootstrap';

/** Labels shown on the button depending on its current state. */
const BUTTON_LABELS = {
  adding:      'Agregando…',
  alreadyIn:   'Ya está en tu carrito',
  default:     'Añadir al Carrito',
};

/**
 * Renders the "Add to Cart" button and the success feedback alert.
 * Contains no business logic — all state and actions come from the parent.
 *
 * @param {object}   props
 * @param {Function} props.onAdd           - Called when the button is clicked.
 * @param {boolean}  props.isAdding        - True while the API request is in-flight.
 * @param {boolean}  props.isAlreadyInCart - True when this product is already in the cart.
 * @param {boolean}  props.isLocked        - True when the cart is locked (receipt under review).
 * @param {boolean}  props.addedToCart     - True briefly after a successful add (shows alert).
 */
export default function AddToCartButton({ onAdd, isAdding, isAlreadyInCart, isLocked, addedToCart }) {
  const isDisabled = isLocked || isAlreadyInCart || isAdding;

  const buttonLabel = isAdding
    ? BUTTON_LABELS.adding
    : isAlreadyInCart
    ? BUTTON_LABELS.alreadyIn
    : BUTTON_LABELS.default;

  const buttonTitle = isLocked
    ? 'Carrito bloqueado: pago en revisión'
    : isAlreadyInCart
    ? 'Este producto ya está en tu carrito'
    : BUTTON_LABELS.default;

  return (
    <>
      {addedToCart && (
        <Alert variant="success" className="mb-3 py-2 text-center">
          ✓ Producto añadido al carrito
        </Alert>
      )}

      <Button
        variant="primary"
        size="lg"
        className="fw-bold w-100"
        onClick={onAdd}
        disabled={isDisabled}
        title={buttonTitle}
      >
        {buttonLabel}
      </Button>
    </>
  );
}

AddToCartButton.propTypes = {
  onAdd:           PropTypes.func.isRequired,
  isAdding:        PropTypes.bool.isRequired,
  isAlreadyInCart: PropTypes.bool.isRequired,
  isLocked:        PropTypes.bool.isRequired,
  addedToCart:     PropTypes.bool.isRequired,
};
